import React, { useState, useEffect } from 'react';
import { db, auth } from '../../firebase';
import { ref, onValue, update } from 'firebase/database';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaArrowLeft } from 'react-icons/fa';

const AuditSocietyDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(false);
    const [formData, setFormData] = useState({
        societyName: '',
        societyAddress: '',
        registrationDistrict: '',
        registrarOffice: '',
        registrationDate: '',
        taluka: '',
        economicStability: '',
        ownCapital: '',
        govtShare: '',
        registrationClass: '',
        inspectionClass: '',
        otherDeptDetails: '',
        memberInOtherSociety: '',
        chairmanName: '',
        chairmanWhatsapp: '',
        chairmanAadhar: '',
        societyPan: '',
        societyGst: '',
        chairmanAddress: '',
        email: ''
    });

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (!user) navigate('/login');
        });

        if (id) {
            const societyRef = ref(db, `ekamwatapzp/SocietyRegistrations/${id}`);
            const unsubData = onValue(societyRef, (snapshot) => {
                if (snapshot.exists()) {
                    setFormData(prev => ({ ...prev, ...snapshot.val() }));
                } else {
                    toast.error("Society data not found");
                    navigate('/audit/societies/new');
                }
                setLoading(false);
            });

            return () => {
                unsubscribe();
                unsubData();
            };
        }
    }, [id, navigate]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        setUpdating(true);
        try {
            const societyRef = ref(db, `ekamwatapzp/SocietyRegistrations/${id}`);
            await update(societyRef, formData);
            toast.success("Profile Updated Successfully!");
        } catch (error) {
            toast.error("Error updating profile: " + error.message);
        } finally {
            setUpdating(false);
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#1a1a4d]"></div>
            </div>
        );
    }

    return (
        <div className="p-4 md:p-8 bg-[#f4f7fe] min-h-screen font-sans">
            {/* Header Area */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
                <div className="flex items-center gap-4">
                    <button 
                        onClick={() => navigate(-1)}
                        className="p-2.5 bg-white rounded-lg shadow-sm border border-gray-100 text-[#1a1a4d] hover:bg-gray-50 transition active:scale-95"
                        title="Back"
                    >
                        <FaArrowLeft />
                    </button>
                    <h1 className="text-xl font-bold text-gray-800">संस्थांची संपूर्ण माहिती (Audit)</h1>
                </div>
                <div className="text-sm font-medium text-gray-500">
                    सांगली जिल्हा परिषद  /  <span className="text-gray-400">संस्थांची संपूर्ण माहिती</span>
                </div>
            </div>

            {/* Form Card */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-8">
                <form onSubmit={handleUpdate} className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    
                    {/* Society Name */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            मजूर सहकारी संस्थेचे नाव <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="text" name="societyName" value={formData.societyName} onChange={handleInputChange}
                            placeholder="मजूर सहकारी संस्थेचे नाव"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition"
                        />
                    </div>

                    {/* Society Address */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            मजूर सहकारी संस्थेचे संपूर्ण पत्ता <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="text" name="societyAddress" value={formData.societyAddress} onChange={handleInputChange}
                            placeholder="मजूर सहकारी संस्थेचे संपूर्ण पत्ता"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition"
                        />
                    </div>

                    {/* Registration District */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            मजूर सहकारी संस्थेची नोंदणी करणारे जिल्हा <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="text" name="registrationDistrict" value={formData.registrationDistrict} onChange={handleInputChange}
                            placeholder="नोंदणी करणारे जिल्हा"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition"
                        />
                    </div>

                    {/* Registrar Office */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            उपनिबंधक / सहाय्यक उपनिबंधक <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="text" name="registrarOffice" value={formData.registrarOffice} onChange={handleInputChange}
                            placeholder="उपनिबंधक / सहाय्यक उपनिबंधक"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition"
                        />
                    </div>

                    {/* Registration Date */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            नोंदणी दिनांक <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="date" name="registrationDate" value={formData.registrationDate} onChange={handleInputChange}
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition"
                        />
                    </div>

                    {/* Taluka */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            तालुका <span className="text-red-500">*</span>
                        </label>
                        <select 
                            name="taluka" value={formData.taluka} onChange={handleInputChange}
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition appearance-none bg-no-repeat bg-[right_1rem_center] bg-white"
                            style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 24 24\' stroke=\'currentColor\'%3E%3Cpath stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'2\' d=\'M19 9l-7 7-7-7\'/%3E%3C/svg%3E")', backgroundSize: '1em' }}
                        >
                            <option value="">निवडा</option>
                            <option value="Miraj">मिरज</option>
                            <option value="Tasgaon">तासगाव</option>
                            <option value="Kavathe Mahankal">कवठे महांकाळ</option>
                            <option value="Walwa">वाळवा</option>
                            <option value="Shirala">शिराळा</option>
                            <option value="Khanapur">खानापूर</option>
                            <option value="Atpadi">आटपाडी</option>
                            <option value="Jat">जत</option>
                            <option value="Kadegaon">कडेगाव</option>
                            <option value="Palus">पलूस</option>
                        </select>
                    </div>

                    {/* Economic Stability */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            मजूर सहकारी संस्थेचे आर्थिक स्थैर्य <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="text" name="economicStability" value={formData.economicStability} onChange={handleInputChange}
                            placeholder="आर्थिक स्थैर्य"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition"
                        />
                    </div>

                    {/* Own Capital */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            स्वत:चे भाग भांडवल <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="text" name="ownCapital" value={formData.ownCapital} onChange={handleInputChange}
                            placeholder="स्वत:चे भाग भांडवल"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition"
                        />
                    </div>

                    {/* Govt Share */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            शासकीय सहभाग रू. <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="text" name="govtShare" value={formData.govtShare} onChange={handleInputChange}
                            placeholder="शासकीय सहभाग रू."
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition"
                        />
                    </div>

                    {/* Registration Class */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            कोणत्या वर्गात नोंदणी हवी आहे <span className="text-red-500">*</span>
                        </label>
                        <select 
                            name="registrationClass" value={formData.registrationClass} onChange={handleInputChange}
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition appearance-none bg-no-repeat bg-[right_1rem_center] bg-white"
                            style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 24 24\' stroke=\'currentColor\'%3E%3Cpath stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'2\' d=\'M19 9l-7 7-7-7\'/%3E%3C/svg%3E")', backgroundSize: '1em' }}
                        >
                            <option value="">निवडा</option>
                            <option value="A">अ</option>
                            <option value="B">ब</option>
                            <option value="C">क</option>
                        </select>
                    </div>

                    {/* Inspection Class */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            मजूर सहकारी संस्थेचे मिळालेला तपासणी वर्ग <span className="text-red-500">*</span>
                        </label>
                        <select 
                            name="inspectionClass" value={formData.inspectionClass} onChange={handleInputChange}
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition appearance-none bg-no-repeat bg-[right_1rem_center] bg-white"
                            style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 24 24\' stroke=\'currentColor\'%3E%3Cpath stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'2\' d=\'M19 9l-7 7-7-7\'/%3E%3C/svg%3E")', backgroundSize: '1em' }}
                        >
                            <option value="">निवडा</option>
                            <option value="A">अ</option>
                            <option value="B">ब</option>
                            <option value="C">क</option>
                            <option value="D">ड</option>
                        </select>
                    </div>

                    {/* Other Dept Details */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            इतर कोणत्या खात्याकडे संस्थेचे वर्गीकरण झाले आहे काय, असल्यास त्याचा तपशील. <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="text" name="otherDeptDetails" value={formData.otherDeptDetails} onChange={handleInputChange}
                            placeholder="तपशील"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition"
                        />
                    </div>

                    {/* Member in Other Society */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            मजूर सहकारी संस्थेचा कोणी सभासद इतर संस्थेत सभासद आहे काय? <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="text" name="memberInOtherSociety" value={formData.memberInOtherSociety} onChange={handleInputChange}
                            placeholder="हो/नाही"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition"
                        />
                    </div>

                    {/* Chairman Name */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            अर्ज करतेवेळच्या संस्थेच्या चेअरमेनचे नाव <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="text" name="chairmanName" value={formData.chairmanName} onChange={handleInputChange}
                            placeholder="चेअरमेनचे नाव"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition"
                        />
                    </div>

                    {/* Chairman WhatsApp */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            चेअरमेन व्हॉट्सॲप नंबर <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="text" name="chairmanWhatsapp" value={formData.chairmanWhatsapp} onChange={handleInputChange}
                            placeholder="व्हॉट्सॲप नंबर"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition bg-gray-50"
                            disabled
                        />
                    </div>

                    {/* Aadhar */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            आधार क्रमांक <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="text" name="chairmanAadhar" value={formData.chairmanAadhar} onChange={handleInputChange}
                            placeholder="आधार क्रमांक"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition bg-gray-50"
                            disabled
                        />
                    </div>

                    {/* PAN */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            पॅन क्रमांक <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="text" name="societyPan" value={formData.societyPan} onChange={handleInputChange}
                            placeholder="पॅन क्रमांक"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition bg-gray-50"
                            disabled
                        />
                    </div>

                    {/* GST */}
                    <div className="space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            जी.एस.टी क्रमांक <span className="text-red-500">*</span>
                        </label>
                        <input 
                            type="text" name="societyGst" value={formData.societyGst} onChange={handleInputChange}
                            placeholder="जी.एस.टी क्रमांक"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition bg-gray-50"
                            disabled
                        />
                    </div>

                    {/* Chairman Address */}
                    <div className="md:col-span-2 space-y-2">
                        <label className="text-[13px] font-bold text-gray-700 flex items-center gap-1">
                            मजूर सहकारी संस्थेच्या चेअरमेनचे पत्ता <span className="text-red-500">*</span>
                        </label>
                        <textarea 
                            name="chairmanAddress" value={formData.chairmanAddress} onChange={handleInputChange}
                            rows="2"
                            placeholder="चेअरमेनचे पत्ता"
                            className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-blue-500 outline-none transition resize-none"
                        ></textarea>
                    </div>

                    {/* Action Buttons */}
                    <div className="md:col-span-2 flex items-center gap-3 pt-4">
                        <button 
                            type="submit"
                            disabled={updating}
                            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg text-sm font-bold transition shadow-md active:scale-95 disabled:opacity-50"
                        >
                            {updating ? 'Updating...' : 'Update Profile'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AuditSocietyDetails;
